import CookieSet from 'common/util/CookieSet';

export default function () {
	const recentSet = CookieSet('shop_recently', handleUpdateFavoriteSet);

	function handleUpdateFavoriteSet(info) {
		const product_id = +info.value;

		$('.js-recent-button').filter(`[data-product-id="${product_id}"]`).each(function () {
			if (info.action === 'add') {
				$(this).addClass('js-active');
			} else {
				$(this).removeClass('js-active');
			}
		});

		$(document).trigger('shop_update_recent', [info, recentSet]);
	}

	const _private = {
		add: product_id => {
			recentSet.add(product_id);
		},

		remove: product_id => {
			recentSet.remove(product_id);
		},

		toggle: product_id => {
			if (recentSet.has(product_id)) {
				_private.remove(product_id);
			} else {
				_private.add(product_id);
			}
		},

		initEventListeners: () => {
			$(document).on('click', '.js-recent-button', function () {
				const product_id = +$(this).data('product-id');

				_private.toggle(product_id);
			});
		}
	};

	_private.initEventListeners();
}
